import request from '@/utils/request'

// 分页查询活动列表
export function page(query) {
  return request({
    url: '/user/userPrivilegeCampaign/page',
    method: 'get',
    params: query
  })
}

// 获取单个活动详情
export function detail(query) {
  return request({
    url: `/user/userPrivilegeCampaign/detail`,
    method: 'get',
    params: query
  })
}

// 新增活动
export function add(data) {
  return request({
    url: '/user/userPrivilegeCampaign/add',
    method: 'post',
    data: data
  })
}


export function confirm(data) {
    return request({
      url: '/user/userPrivilegeCampaign/confirm',
      method: 'post',
      data: data
    })
  }  

// 更新活动
export function update(data) {
  return request({
    url: '/user/userPrivilegeCampaign/update',
    method: 'post',
    data: data
  })
}

// 删除活动
export function del(data) {
  return request({
    url: `/user/userPrivilegeCampaign/del`,
    method: 'post',
    data: data
  })
}
